import { FC } from 'react';
import { Text, View } from 'react-native';
import dayjs from 'dayjs';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { COLORS, FONTS } from '../../constants';
import { IBookingState } from '../../screens/BookingDetail/types';
import { ICamp } from '../../types/camp.types';
import { calculateNumberOfNights } from '../../services/utils/dateConvert';

type BasicBookingInfoProps = {
  data: IBookingState;
  camp: ICamp;
};

const BasicBookingInfo: FC<BasicBookingInfoProps> = ({ data, camp }) => {
  const isDesktop = useIsDesktop();
  return (
    <View
      style={[
        {
          backgroundColor: '#f9f2f1',
        },
        isDesktop()
          ? {
              flexDirection: 'row',
              justifyContent: 'space-between',
              gap: 5,
            }
          : {
              flexDirection: 'column',
              gap: 20,
            },
      ]}
    >
      <View
        style={[
          isDesktop() && {
            flex: 1,
          },
        ]}
      >
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '800',
            fontSize: 19,
            letterSpacing: 1,
            marginBottom: 15,
            color: COLORS.BLACK,
          }}
        >
          Check In:
        </Text>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '500',
            fontSize: 16,
            color: COLORS.GREY,
            marginBottom: 13,
          }}
        >
          {dayjs(new Date(data.start_date)).format('ddd DD MMMM YYYY')}
        </Text>

        <View
          style={{
            flexDirection: 'row',
          }}
        >
          <View
            style={{
              paddingHorizontal: 13,
              paddingVertical: 8,
              borderRadius: 18,
              backgroundColor: COLORS.LIGHT_GREY,
            }}
          >
            <Text
              style={{
                fontFamily: FONTS.AvenirMedium,
                fontSize: 14,
                fontWeight: '500',
                color: COLORS.BLACK,
              }}
            >
              {camp.start_time}
            </Text>
          </View>
        </View>
      </View>
      <View
        style={[
          isDesktop() && {
            flex: 1,
          },
        ]}
      >
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '800',
            fontSize: 19,
            letterSpacing: 1,
            marginBottom: 15,
            color: COLORS.BLACK,
          }}
        >
          Check Out:
        </Text>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '500',
            fontSize: 16,
            color: COLORS.GREY,
            marginBottom: 13,
          }}
        >
          {dayjs(new Date(data.end_date)).format('ddd DD MMMM YYYY')}
        </Text>
        <View
          style={{
            flexDirection: 'row',
          }}
        >
          <View
            style={{
              paddingHorizontal: 13,
              paddingVertical: 8,
              borderRadius: 18,
              backgroundColor: COLORS.LIGHT_GREY,
            }}
          >
            <Text
              style={{
                fontFamily: FONTS.AvenirMedium,
                fontSize: 14,
                fontWeight: '500',
                color: COLORS.BLACK,
              }}
            >
              {camp.end_time}
            </Text>
          </View>
        </View>
      </View>
      {camp.room_availability && (
        <View
          style={[
            isDesktop() && {
              flex: 1,
            },
          ]}
        >
          <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '800',
              fontSize: 19,
              letterSpacing: 1,
              marginBottom: 15,
              color: COLORS.BLACK,
            }}
          >
            Number of Nights:
          </Text>
          <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '500',
              fontSize: 16,
              color: COLORS.GREY,
              marginBottom: 13,
            }}
          >
            {calculateNumberOfNights(data.start_date, data.end_date)} Nights
          </Text>
        </View>
      )}
      <View
        style={[
          isDesktop() && {
            flex: 1,
          },
        ]}
      >
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '800',
            fontSize: 19,
            letterSpacing: 1,
            marginBottom: 15,
            color: COLORS.BLACK,
          }}
        >
          Number of People:
        </Text>
        <Text
          style={{
            fontFamily: FONTS.AvenirMedium,
            fontWeight: '500',
            fontSize: 16,
            color: COLORS.GREY,
            marginBottom: 13,
          }}
        >
          {data.total_guest} People
        </Text>
      </View>
    </View>
  );
};

export default BasicBookingInfo;
